/**
 * Entry point.
 *
 * Stylesheet order matters: Bootstrap first, then the ported design system, so
 * `app.css` can override Bootstrap's defaults without `!important` everywhere.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/app.css';
import './styles/react-overrides.css';

import App from './App.jsx';
import { store } from './app/store.js';
import { queryClient } from './app/queryClient.js';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
);
